import has from 'lodash/has'
import { clanPlayersOnlineStatus, playerFriendsOnlineStatus } from 'react-wot-bootstrap'
import { getCurrentLanguage } from 'locale'

const ONLINE_STATUS_MAP = ['offline', 'online', 'busy']

const URLs = {
    ANNOUNCEMENTS: (host, clanId) => `${host}/wgcp/billboard/?clan_id=${clanId}`,
    AUTHORS: (host, authors) => `${host}/accounts/names/?id=${authors.join(',')}`,
    SETTINGS: (host) => `${host}/wgcp/billboard/setting/`,
    CREATE: (host) => `${host}/wgcp/billboard/new/`,
    EDIT: (host, messageId) => `${host}/wgcp/billboard/messages/${messageId}/edit/`,
    ARCHIVE: (host, messageId) => `${host}/wgcp/billboard/messages/${messageId}/archive/`,
    DELETE: (host, messageId) => `${host}/wgcp/billboard/messages/${messageId}/delete/`,
}

const requestData = async (url, method, body) => {
    const response = await fetch(url, {
        method: method || 'GET',
        credentials: 'include',
        body: body && JSON.stringify(body),
    })

    const parsedResponse = await response.json()

    if (!response.ok) {
        throw parsedResponse
    }

    return parsedResponse
}

export const getAnnouncements = async (host, clanId) => {
    const url = URLs.ANNOUNCEMENTS(host, clanId)

    const response = await requestData(url)

    if (response.length) {
        const authors = response.map(item => item.editor_id || item.author_id)
        const spaUrl = URLs.AUTHORS(host, authors)
        const spaResponse = await requestData(spaUrl)

        const onlineStatus = await clanPlayersOnlineStatus()
        const friendsOnlineStatus = await playerFriendsOnlineStatus()

        response.forEach(item => {
            const author = spaResponse.find(account => {
                return (
                    account.id === item.editor_id ||
                    account.id === item.author_id
                )
            })
            item.author_name = author.name
            item.author_status = ONLINE_STATUS_MAP[onlineStatus[item.author_id]]
            item.author_is_friend = has(friendsOnlineStatus, author.id)
            item.created_at = item.updated_at || item.created_at
        })
    }

    return response
}

export const getSettings = async (host) => {
    const url = URLs.SETTINGS(host)
    const response = await requestData(url)

    const language = getCurrentLanguage()
    const privacyPolicyLink = response.privacy_policy_link.replace(/\%s/, language)

    return {
        ...response,
        privacy_policy_link: privacyPolicyLink,
    }
}

export const requestAnnouncements = async (host, clanId) => {
    return await Promise.all([getAnnouncements(host, clanId), getSettings(host)])
}

export const createAnnouncement = async (host, body) => {
    const url = URLs.CREATE(host)
    const response = await requestData(url, 'POST', body)

    return response
}

export const editAnnouncement = async (host, body) => {
    const url = URLs.EDIT(host, body.message_id)
    const response = await requestData(url, 'POST', body)

    return response
}

export const archiveAnnouncement = async (host, body) => {
    const url = URLs.ARCHIVE(host, body.message_id)
    const response = await requestData(url, 'POST', body)

    return response
}

export const deleteAnnouncement = async (host, body) => {
    const url = URLs.DELETE(host, body.message_id)
    const response = await requestData(url, 'POST', body)

    return response
}



// WEBPACK FOOTER //
// ./state/actions/announcements/api.js